import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Modal } from "../../../../../../../../_metronic/elements/Modal";
import { openAlert } from "../../../../../../../../_metronic/elements/NotificationAlert";
import { useErrorHandler } from "../../../../../../../../_metronic/helpers/ErrorHandler";
import { useViewAmbientContext } from "../AmbientsContext";
import { useMapLegendContext } from '../../Helpers/MapLegend';
import { useViewImageContext } from "../../Images/ViewImageContext";
import * as GisDataAdapter from "../../../../services/GisDataAdapter";
import {
  buildPlanetHdAmbientCancelPayload,
  clearPlanetHdAmbientCancelRequest,
  getOrCreatePlanetHdAmbientCancelRequest,
} from "../planetHdAmbientCancelRequest";

const ModalHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="modal-header p-5">
      <h5 className="modal-title">{t("ambient:delete.title")}</h5>
    </div>
  );
};

const ModalFooter = ({ deleteAmbient, loading, setDeleteAmbient }) => {
  const { t } = useTranslation();
  return (
    <div className="modal-footer">
      <button onClick={() => setDeleteAmbient(false)} disabled={loading == true} type="button" className="btn btn-light">
        {t("ambient:delete.buttons.cancel")}
      </button>
      <button onClick={deleteAmbient} type="button" className="btn btn-danger">
        {!loading && t("ambient:delete.buttons.delete")}
        {loading && (
          <span className='indicator-progress' style={{ display: 'block' }}>
            {t("ambient:delete.messages.deleting")}{' '}
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
        )}
      </button>
    </div>
  );
};

const DeleteAmbient = () => {
  const [loading, setLoading] = useState(false);
  const { land_id } = useParams();
  const {
    loadAmbientData,
    loadAmbientHdData,
    loadImageAmbientData,
    loadImageAmbientHdData,
    ambientHdData,
    deleteAmbient,
    imageAmbientHdData,
    setDeleteAmbient,
    selectedElement,
    setSelectedElement
  } = useViewAmbientContext();
  const viewImageContext = useViewImageContext();
  const mapLegendContext = useMapLegendContext();
  const { errorHandler } = useErrorHandler();
  const { t } = useTranslation();

  const deleteAmbientFunc = async () => {
    setLoading(true);
    let res;
    let hdCancelRequest = null;
    if (selectedElement === "imageAmbient"){
      res = await errorHandler(GisDataAdapter.deleteLandImageAmbient(land_id));
    }
    else if (selectedElement === "imageAmbientHd") {
      hdCancelRequest = getOrCreatePlanetHdAmbientCancelRequest({
        ambientId: imageAmbientHdData?.ambient_id || imageAmbientHdData?.request_id,
        landId: land_id,
        source: selectedElement,
      });
      res = await errorHandler(GisDataAdapter.deleteLandImageAmbientHd(
        land_id,
        buildPlanetHdAmbientCancelPayload(hdCancelRequest.requestId)
      ));
    }
    else if (selectedElement === "ambientHd") {
      hdCancelRequest = getOrCreatePlanetHdAmbientCancelRequest({
        ambientId: ambientHdData?.ambient_id || ambientHdData?.request_id,
        landId: land_id,
        source: selectedElement,
      });
      res = await errorHandler(GisDataAdapter.deleteLandAmbientHd(
        land_id,
        buildPlanetHdAmbientCancelPayload(hdCancelRequest.requestId)
      ));
    }
    else {
      res = await errorHandler(GisDataAdapter.deleteLandAmbient(land_id));
    }
    

    if (res && res.ok) {
      if (hdCancelRequest?.storageKey) {
        clearPlanetHdAmbientCancelRequest(hdCancelRequest.storageKey);
      }
      setSelectedElement(null);
      mapLegendContext.deleteAll();
      viewImageContext.closeAllImages();
      await Promise.all([
        loadAmbientData(),
        loadAmbientHdData(),
        loadImageAmbientData(),
        loadImageAmbientHdData()
      ]);
      setDeleteAmbient(false);
      openAlert('success', t("ambient:delete.messages.success"), '');
    }

    setLoading(false);
  };

  return (
    <>
      <Modal open={deleteAmbient} setOpen={setDeleteAmbient}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <ModalHeader />
            <ModalFooter deleteAmbient={deleteAmbientFunc} setDeleteAmbient={setDeleteAmbient} loading={loading} />
          </div>
        </div>
      </Modal>
    </>
  )
};

export default DeleteAmbient;
